import {
  type ConversationsProps,
  type ConversationItemType,
} from "./antdx";
import React from "react";

type OmitItems = Omit<ConversationsProps, "items" | "style">;

export interface SessionData extends ConversationItemType {
  meta?: any;
}

export interface XAiConversationsProps extends OmitItems {
  /** 配色 */
  color?: string;
  /** 侧边栏展示形式,若为 true 则为抽屉式展示 */
  isNarrow?: boolean;
  /** 会话列表，替换原来的 items 字段 */
  sessionList?: SessionData[];
  /** session总数，当设置该值时，会增加自动加载逻辑 */
  sessionTotal?: number;
  /** 加载更多函数 */
  loadMoreSession?: () => void;
  /** 点击生成新对话回调 */
  onNewChat?: () => void;
  style?: React.CSSProperties;
}
